/**
 * A type guard to assert that a passed property key is a property on the passed object.
 *
 * @param obj The object to test if the key is present for
 * @param k The key to test if it is a member of an object
 * @returns True if the key is present in the passed object
 */
export default function keyInObject<TObj extends object>(
  obj: TObj,
  k: PropertyKey,
): k is keyof TObj {
  return obj.hasOwnProperty(k);
}
